import { styled, Tooltip } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useCallback, useState } from 'react'
import { VersionReportVersionEntity } from '../../../../../domain/entity/version-report/VersionReportVersionEntity'
import { VersionInfoDialog } from '../dialog/VersionInfoDialog'
import { HeaderIconButton } from './common'
import { colorPalette } from '../../../../style/colorPalette'
import { intl } from '../../../../../i18n'

type VersionInfoProps = {
  version: VersionReportVersionEntity | undefined
}
export const VersionInfo = ({ version }: VersionInfoProps) => {
  const [open, setOpen] = useState<boolean>(false)
  const onOpen = useCallback(() => setOpen(true), [])
  const onClose = useCallback(() => setOpen(false), [])
  return (
    <>
      <Tooltip
        title={intl.formatMessage({
          id: 'versionReport.tooltip.versionInfoButton',
        })}
      >
        <HeaderIconButton onClick={onOpen}>
          <InfoIcon />
        </HeaderIconButton>
      </Tooltip>
      <VersionInfoDialog open={open} version={version} onClose={onClose} />
    </>
  )
}
const InfoIcon = styled(InfoOutlinedIcon)({
  color: colorPalette.monotone[4],
})
